(function () {
    'use strict';
    $(document).ready(function () {

        particlesJS.load('particles-js', '/wp-content/themes/wp-bootstrap-gulp/includes/particles.json');

        $('#cyberdefender-form .field-checkbox .expand, #cyberdefender-form-survey .field-checkbox .expand').on('click', function (e) {
            e.preventDefault();
            $(this).siblings('label').children('p:not(:first-child)').slideToggle();
            var text = $(this).text();
            $(this).text(text == "Pokaż więcej" ? "Pokaż mniej" : "Pokaż więcej");
        });

        //Form logic
        function sendCyberdefenderForm(formId, formSuffix) {

            var cyberdefenderName = $('input[name=cf-name' + formSuffix + ']').val();
            var cyberdefenderEmail = $('input[name=cf-email' + formSuffix + ']').val();
            var cyberdefenderPhone = $('input[name=cf-phone' + formSuffix + ']').val();

            var cyberdefenderConsents = [];
            $('.field-checkbox-consent' + formSuffix).each(function () {
                var consentText = $(this).find('label').text();
                var consentAnswer = $(this).find('input[type=checkbox]:checked').val() ? 'TAK' : 'NIE';
                var consentAnswer = {
                    "consentText": consentText,
                    "consentAnswer": consentAnswer,
                }
                cyberdefenderConsents.push(consentAnswer);
            });

            var cyberdefenderQuestions = [];
            if (formId == '#cyberdefender-form-survey') {
                $('.field-checkbox-toggle').each(function () {
                    var questionText = $(this).find('.text').text();
                    var questionAnswer = $(this).find('input[type=checkbox]:checked').val() ? 'TAK' : 'NIE';
                    var questionAnswer = {
                        "questionText": questionText,
                        "questionAnswer": questionAnswer,
                    }
                    cyberdefenderQuestions.push(questionAnswer);
                });
            }

            var cyberdefenderDetails = {
                "cyberdefenderName": cyberdefenderName,
                "cyberdefenderEmail": cyberdefenderEmail,
                "cyberdefenderPhone": cyberdefenderPhone,
                "cyberdefenderConsents": cyberdefenderConsents,
                "cyberdefenderQuestions": cyberdefenderQuestions,
            }

            var cyberdefenderDetailsJSON = JSON.stringify(cyberdefenderDetails);

            grecaptcha.ready(function () {
                grecaptcha.execute('6LccmOYeAAAAAOMTOqH_LE0GRjrkvcg421ubEHfY', {action: 'submit'}).then(function (token) {
                    $.ajax({
                        url: "/wp-admin/admin-ajax.php",
                        method: "post",
                        timeout: 10000,
                        data: {
                            action: "send_cyberdefender_form",
                            cyberdefenderDetailsJSON: cyberdefenderDetailsJSON,
                            recaptcha_token: token,
                        },
                        success: function (data) {
                            if (data == '1') {
                                $(formId + ' .ajax-success').slideDown();
                                $(formId).trigger("reset");
                            } else {
                                $(formId + ' .ajax-error').slideDown();
                            }
                        },
                        error: function (data) {
                            $(formId + ' .ajax-error').slideDown();
                        },
                        beforeSend: function () {
                            $(formId + ' .ajax-success').slideUp();
                            $(formId + ' .ajax-loading').slideDown();
                            $(formId + ' .ajax-error').slideUp();
                        },
                        complete: function () {
                            $(formId + ' .ajax-loading').slideUp();
                        },
                    });
                })
            });

        }

        function validateEmail(email) {
            const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(email).toLowerCase());
        }

        $('#cf-submit, #cf-submit-survey').on('click', function (e) {
            e.preventDefault();
            var cyberdefenderFormId = '#' + $(this).closest('form').attr('id');
            var formSuffix = '';
            if (cyberdefenderFormId == '#cyberdefender-form-survey') {
                var formSuffix = '-survey';
            }
            $(cyberdefenderFormId + ' .cf-error').hide();

            var isAllValid = true;

            var fieldsToValidationText = ['#cf-name' + formSuffix];
            $(fieldsToValidationText).each(function (index, element) {
                if (!$(element).val()) {
                    $(this).siblings('.cf-error').slideDown();
                    isAllValid = false;
                }
            });

            if (validateEmail($('#cf-email' + formSuffix).val()) === false) {
                $('#cf-email' + formSuffix).siblings('.cf-error').slideDown();
                isAllValid = false;
            }

            $('.field-checkbox-consent-required' + formSuffix).each(function () {
                if (!$(this).find('input[type=checkbox]').is(':checked')) {
                    $(this).find('input[type=checkbox]').siblings('.cf-error').slideDown();
                    isAllValid = false;
                }
            });

            if (!isAllValid) {
                return;
            }

            sendCyberdefenderForm(cyberdefenderFormId, formSuffix);
        });

        $('.risk-questions input[type=checkbox]').on('change', function () {
            if ($(".risk-questions input:checkbox:checked").length < $(".risk-questions input:checkbox").length) {
                $('.risk .lead').slideDown();
            } else {
                $('.risk .lead').slideUp();
            }
        });

        var wasUserInteracting = false;
        $(document).on('click', function () {
            wasUserInteracting = true;
        });

        var wasStoppedByUser = false;
        $('.video-container').find('video, .play').on('click', function (e) {
            wasStoppedByUser = true;
            var video = $('.video-container').find('video')[0];
        });

        $(window).on('scroll', function () {
            var video = $('.video-container').find('video')[0];

            if (video !== undefined) {
                console.log("im in");
                var hT = $('.video-container').offset().top;
                var wH = $(window).height();
                var wS = $(this).scrollTop();

                if (wS > (hT - wH)) {
                    var play = $('.video-container').find('.play')[0];
                    if (wasUserInteracting) {
                        if (!wasStoppedByUser) {
                            if (video.paused) {
                                video.play();
                                $(play).fadeOut();
                            }
                        }
                    } else {
                        if (!wasStoppedByUser) {
                            if (video.paused) {
                                video.play();
                                $(play).fadeOut();
                            }
                        }
                    }
                }
            }
        });

    });
}(jQuery));
